import {AfterContentInit, Component, Input}  from '@angular/core';
import {ApPpPlanningWizardOverviewStatsItem} from './types/ap-pp-planning-wizard-overview-stats.types';
import {ApDynGridColumnConfigBase} from '../../../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {Observable, of}            from 'rxjs';
import {ApDynGridPropertyColumnConfig}       from '../../../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {nameOf}                              from '../../../../ap-core/utils/ap-name-of';

@Component({
  selector: 'ap-pp-planning-wizard-overview-stats',
  templateUrl: 'ap-pp-planning-wizard-overview-stats.component.html',
  styleUrls: ['ap-pp-planning-wizard-overview-stats.component.scss']
})
export class ApPpPlanningWizardOverviewStatsComponent implements AfterContentInit {
  @Input() public data: ApPpPlanningWizardOverviewStatsItem[];
  @Input() public title: string;
  @Input() public emptyMessage = '';

  public statColumns: ApDynGridColumnConfigBase[] = [];
  public statItems$: Observable<ApPpPlanningWizardOverviewStatsItem[]>;

  public ngAfterContentInit(): void {
    if (!this.data || this.data.length <= 0) {
      return;
    }
    this.statColumns = this.getStatColumns();
    this.statItems$ = of(this.data);
  }

  private getStatColumns(): ApDynGridColumnConfigBase[] {
    return [
      new ApDynGridPropertyColumnConfig({
        field: nameOf<ApPpPlanningWizardOverviewStatsItem>('key'),
        style: {'font-weight': 600, 'background-color': 'silver'},
        cssClass: 'left',
        width: 100,
        filterable: false,
        sortable: false
      }),
      new ApDynGridPropertyColumnConfig({
        field: nameOf<ApPpPlanningWizardOverviewStatsItem>('value'),
        cssClass: 'left',
        filterable: false,
        sortable: false,
        multiline: true
      })];
  }
}
